'use client';

import { Button } from '@shared/components/shadcn';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { GamesModal } from '../GamesModal/GamesModal';

type BrowseGamesButtonProps = {
  gamesNames: string[];
};

function BrowseGamesButton({ gamesNames }: BrowseGamesButtonProps) {
  const t = useTranslations('offers.page.obs.offer.cta');
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Button variant="primary" onClick={() => setIsOpen(true)} data-testid="browse-games-button" data-track-name="Browse Games">
        <span className="btn-label-s">{t('games')}</span>
      </Button>
      <GamesModal gamesNames={gamesNames} isOpen={isOpen} onOpenChange={setIsOpen} data-track-container="Eligible Games" />
    </>
  );
}

export { BrowseGamesButton };
